import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Grid2 } from "@mui/material";
import Loader from "../../../../components/Loader";
import UncontrolledSearchSelect from "../../../../components/UncontrolledSearchSelect";
import CapsTableComponent from "../../../../components/CapsTableComponent/CapsTableComponent";
import {
  addStudyCapsService,
  deleteSiteCap,
  getStudySiteCapDataService,
  updateStudyDetailsService,
} from "../../../../services/siteManagamentService";
import { notifySuccess, notifyWarning } from "../../../../utilities/helper";

const SiteCaps = () => {
  const [load, setLoad] = useState(false);
  const [selectedSite, setSelectedSite] = useState("");
  const [capData, setCapData] = useState([]);
  const [statusData, setStatusData] = useState([]);

  const siteId = useLocation()?.state?.id;

  const navigate = useNavigate();

  const access_token = localStorage?.getItem("access_token");

  const role = localStorage.getItem("role");
  const roleId = localStorage.getItem("roleId");
  const globalDateFormat = localStorage.getItem("globalDateFormat");

  useEffect(() => {
    if (siteId) {
      getOnLoadData(siteId);
    }
  }, [siteId]);

  const getOnLoadData = async (siteId) => {
    try {
      setLoad(true);
      const res = await getStudySiteCapDataService(access_token, siteId);
      if (
        res?.status === 200 &&
        res?.data?.message === "Onload Data Extracted!"
      ) {
        setStatusData(res?.data?.result?.patientStatusTypes || []);
        const data = res?.data?.result?.caps?.map((item) => ({
          ...item,
          targetCount: item?.targetCount || "",
        }));
        setCapData(data || []);
        setLoad(false);
      }
    } catch (err) {
      console.log("Error : ", err);
      setLoad(false);
      if (err?.status === 401) {
        navigate("/unAuthorize");
      }
    }
  };

  const createRow = async () => {
    try {
      setLoad(true);
      const payload = {
        siteId: siteId,
        patientStatusTypeId: selectedSite,
        userId: roleId,
      };
      const res = await addStudyCapsService(
        access_token,
        roleId,
        globalDateFormat,
        payload,
      );
      if (
        res?.status == 200 &&
        res?.data?.message === "Cap added successfully!"
      ) {
        setLoad(false);
        getOnLoadData(siteId);
        setSelectedSite("");
        notifySuccess("Cap Added successfully");
      }
    } catch (err) {
      console.log("Error : ", err);
      setLoad(false);
      if (err?.status === 401) {
        navigate("/unAuthorize");
      }
    }
  };

  const updateDetails = async () => {
    try {
      setLoad(true);
      const payload = capData?.map((item) => ({
        id: item?.id,
        alertCapCount: item?.alertCapCount,
        stopCapCount: item?.stopCapCount,
        targetCount: Number(item?.targetCount) || null,
      }));
      const res = await updateStudyDetailsService(
        access_token,
        roleId,
        globalDateFormat,
        siteId,
        payload,
      );
      if (res?.status === 200) {
        setLoad(false);
        notifySuccess("Cap details updated successfully");
        getOnLoadData(siteId);
      }
    } catch (err) {
      console.log("Error : ", err);
      setLoad(false);
      if (
        err?.response?.data?.title === "One or more validation errors occurred."
      ) {
        notifyWarning("Please Enter a valid number");
      }
      if (err?.status === 401) {
        navigate("/unAuthorize");
      }
    }
  };

  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <>
          <Grid2
            container
            alignItems="center"
            justifyContent={"space-between"}
            sx={{ width: "100%", margin: "-1% 2% 2% 0%" }}
            gap={1}
          >
            <Grid2 size={{ xl: 5, md: 5, lg: 5, sm: 12, xs: 12 }}>
              <div>
                <p className="labelStyles">Status</p>

                <div
                  style={{ display: "flex", gap: "10px", alignItems: "center" }}
                >
                  <UncontrolledSearchSelect
                    data={statusData}
                    optionLabel="patientStatusDescription"
                    optionKey="id"
                    value={selectedSite}
                    placeholder="Status"
                    onChange={(selectedValue) => {
                      setSelectedSite(selectedValue);
                    }}
                  />
                  <button
                    className={
                      selectedSite === ""
                        ? "create-btn-outlined disabled"
                        : "create-btn-outlined"
                    }
                    onClick={() => {
                      createRow();
                    }}
                    disabled={selectedSite === "" ? true : false}
                  >
                    Add Cap
                  </button>
                </div>
              </div>
            </Grid2>
          </Grid2>

          <Box sx={{ width: "100%", typography: "body1" }}>
            <CapsTableComponent
              isFullScreen={true}
              rows={capData}
              setRows={setCapData}
              apiName={deleteSiteCap}
              getOnLoadData={getOnLoadData}
              siteId={siteId}
              setLoad={setLoad}
              isFromSiteCaps={true}
            />
          </Box>

          <Grid2
            alignItems={"end"}
            justifyContent="end"
            container
            gap={3}
            sx={{ marginTop: "2%" }}
          >
            <Grid2 item md={6}>
              <button
                type="button"
                className="create-btn-outlined"
                onClick={(e) => {}}
              >
                Back
              </button>
            </Grid2>
            <Grid2 item md={6}>
              <button onClick={updateDetails} className={"create-btn"}>
                Save
              </button>
            </Grid2>
          </Grid2>
        </>
      )}
    </>
  );
};

export default SiteCaps;
